import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OrderCappingToastService } from '../../services/order-capping-toast.service';
import { NgTemplateOutlet } from '@angular/common';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sanofi-order-capping-toasts-container',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    NgbToast,
  ],
  templateUrl: './order-capping-toasts-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'sanofi-orderCapping__toastContainer position-fixed d-flex flex-column align-items-center', style: 'z-index: 1200' },
})
export class OrderCappingToastsContainerComponent {
  toastService = inject(OrderCappingToastService);
}
